import { computed, toValue } from 'vue'
import { defineStore } from 'pinia'
import Projects from '@/classes/projects/Projects'
import ProjectQuery from '@/classes/queries/ProjectQuery'

export const useUserStore = defineStore('UserStore', {
  state: () => ({
    projects: {},
    loader: false,
    error: {}
  }),
  getters: {
    getProjects: state => ({ query, dependencies, multi_currency = true } = {}) => state.$getItems({
      resource: 'projects',
      query: computed(() => new ProjectQuery(toValue(query)).to_database),
      dependencies,
      multi_currency,
      fetch: () => state.fetchProjects({ query })
    }),
  },
  actions: {
    fetchProjects ({ query, multi_currency = true }) {
      return this.$fetchItems({
        endpoint: '/api/v1/user/projects',
        resource: 'projects',
        model: Projects,
        query: new ProjectQuery(toValue(query)).to_database,
        multi_currency
      })
    },
    postUserVerification ({ params }) {
      return this.$postItem({
        endpoint: '/api/v1/users/verification',
        params
      })
    },
    postSendVerificationEmail ({ params }) {
      return this.$postItem({
        endpoint: '/api/v1/users/send_verification_email',
        params
      })
    },
    fetchValidateNationalId ({ query }) {
      return this.$fetchItem({
        endpoint: '/api/v1/users/validate_national_id',
        query
      })
    }
  }
})